import React from "react";

interface LinkedinSvg {
  smallWidth: boolean;
}

const LinkedinSvg: React.FC<LinkedinSvg> = ({ smallWidth }) => {
  return (
    <svg
      className={
        "h-[25px] w-[25px] md:h-[30px] md:w-[30px] lg:h-[35px] lg:w-[35px] xl:h-[43px] xl:w-[43px]"
      }
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.166 42.333c11.69 0 21.167-9.477 21.167-21.166C42.333 9.476 32.856 0 21.167 0 9.476 0 0 9.477 0 21.166c0 11.69 9.477 21.167 21.166 21.167z"
      ></path>
      <path
        fill="#F8F8F8"
        d="M15.94 14a2 2 0 11-4-.002 2 2 0 014 .002zm.06 3.48h-4V30h4V17.48zm6.32 0h-3.98V30h3.94v-6.57c0-3.66 4.77-4 4.77 0V30H31v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
      ></path>
    </svg>
  );
};

export default LinkedinSvg;
